import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { GET_FABRIC_DATA } from '@/graphql/queries';
import AdminPlaceholder from 'components/consumer/AdminPlaceholder';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import FabricPage from './FabricsPage';
const FabricFilter = t0 => {
  const $ = _c(7);
  const {
    isAdmin
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      activeOnly: true
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isAdmin) {
    t2 = {
      skip: isAdmin,
      variables: t1
    };
    $[1] = isAdmin;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data,
    loading
  } = useSuspenseQuery(GET_FABRIC_DATA, t2);
  if (isAdmin) {
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <AdminPlaceholder>Fabric Filter Component Placeholder <br />The component will display correctly in Consumer</AdminPlaceholder>;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  let t3;
  if ($[4] !== data || $[5] !== loading) {
    t3 = <FabricPage loading={loading} data={data} />;
    $[4] = data;
    $[5] = loading;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
FabricFilter.propTypes = {
  isAdmin: PropTypes.bool
};
export default FabricFilter;